import PopUp from "../../containers/PopUp";
import { NavLink } from "react-router-dom";

const PopAddress = ({ setShowStationPopUp, shippingAddress }) => {
  const addressText =
    shippingAddress && shippingAddress !== "כתובת לא נמצאה"
      ? `${shippingAddress.addrCity ? `${shippingAddress.addrCity}, ` : ""}רחוב ${shippingAddress.addrStreet} ${shippingAddress.addrHouse}, דירה ${shippingAddress.addrApartment}`
      : "כתובת לא זמינה";

  return (
    <PopUp
      close={() => setShowStationPopUp(false)}
      width="600px"
      wrapperClassName="popup-wrapper--address"
    >
      <div className="popAddress">
        <div className="titleAddress">הכתובת המעודכנת במערכת</div>
        <div className="userAddress">{addressText}</div>
        <div className="popAddress__actions">
          <button
            type="button"
            className="popAddress__btn popAddress__btn--primary"
            onClick={() => setShowStationPopUp(false)}
          >
            אישור
          </button>
          <NavLink to="/private-area/address">
            <button
              type="button"
              className="popAddress__btn popAddress__btn--secondary"
              onClick={() => setShowStationPopUp(false)}
            >
              עדכון כתובת
            </button>
          </NavLink>
        </div>
      </div>
    </PopUp>
  );
};

export default PopAddress;
